import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
	highRate: {
		id: 'afterRatingWindow.highRateText',
		defaultMessage: 'Мы постараемся улучшить наш сервис',
	},
	lowRate: {
		id: 'afterRatingWindow.lowRateText',
		defaultMessage: 'Ваше мнение важно для нас',
	},
	header: {
		id: 'afterRatingWindow.header',
		defaultMessage: 'Спасибо',
	},
	submitQuestionary: {
		id: 'afterRatingWindow.linkText',
		defaultMessage: 'Пройти опрос',
	},
});
